/**
 * Renders the Like Pool grid on the wishlist page template.
 * Reads liked product handles from localStorage (shared with
 * like-button.js) and fetches each product's live data from Shopify's
 * public /products/{handle}.js endpoint, so prices, images and
 * availability are always current — no app or database needed.
 */
(function () {
  function ready(callback) {
    if (document.readyState !== 'loading') {
      callback();
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
  }

  function setHidden(el, hidden) {
    if (el) el.hidden = hidden;
  }

  function resizeImage(url, width) {
    if (!url) return '';
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + 'width=' + width;
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && Shopify.money_format) {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    return (cents / 100).toFixed(2);
  }

  // If the visitor arrived here from somewhere else on this same site,
  // point the empty-state button back there instead of the generic
  // "all products" fallback that's already in the href by default.
  function setBackLink() {
    var link = document.querySelector('[data-wishlist-back-link]');
    if (!link || !document.referrer) return;
    try {
      var ref = new URL(document.referrer);
      if (ref.origin === window.location.origin && ref.href !== window.location.href) {
        link.href = ref.href;
      }
    } catch (e) {
      // Unparseable or unavailable referrer — leave the default href in place.
    }
  }

  function buildCard(product) {
    var card = document.createElement('div');
    card.className = 'wishlist-card';
    card.setAttribute('data-wishlist-card', '');

    var imageMarkup = product.featured_image
      ? '<img src="' + resizeImage(product.featured_image, 400) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="400" height="533">'
      : '';

    card.innerHTML =
      '<a class="wishlist-card__media" href="' + product.url + '">' + imageMarkup + '</a>' +
      '<div class="wishlist-card__like"></div>' +
      '<h2 class="wishlist-card__title"><a href="' + product.url + '">' + escapeHtml(product.title) + '</a></h2>' +
      '<div class="wishlist-card__price">' + formatMoney(product.price) + '</div>';

    return card;
  }

  function renderLikeButton(container, handle, labels) {
    if (!container) return;
    container.innerHTML =
      '<like-button class="like-button" data-handle="' + handle + '">' +
        '<button type="button" class="like-button__toggle" aria-pressed="true" ' +
          'data-label-add="' + escapeHtml(labels.add) + '" data-label-remove="' + escapeHtml(labels.remove) + '" ' +
          'aria-label="' + escapeHtml(labels.remove) + '">' +
          '<svg class="like-button__icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">' +
            '<path d="M12 20.9c-.24 0-.47-.07-.67-.22C8.9 18.87 2.5 13.98 2.5 8.98 2.5 5.7 5.1 3 8.3 3c1.6 0 3.14.75 4.2 2.02C13.56 3.75 15.1 3 16.7 3c3.2 0 5.8 2.7 5.8 5.98 0 5-6.4 9.89-8.83 11.7-.2.15-.43.22-.67.22z"/>' +
          '</svg>' +
        '</button>' +
      '</like-button>';
  }

  function loadWishlist() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var emptyState = document.querySelector('[data-wishlist-empty]');
    var subtitle = document.querySelector('[data-wishlist-subtitle]');
    if (!grid || !window.VioletEyesLikes) return;

    function showEmpty() {
      setHidden(grid, true);
      setHidden(subtitle, true);
      setHidden(emptyState, false);
    }

    var handles = window.VioletEyesLikes.readLiked();
    if (handles.length === 0) {
      showEmpty();
      return;
    }

    var labels = {
      add: grid.dataset.labelAdd,
      remove: grid.dataset.labelRemove
    };

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (response) { return response.ok ? response.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);

      if (valid.length === 0) {
        window.VioletEyesLikes.writeLiked([]);
        showEmpty();
        return;
      }

      grid.innerHTML = '';
      valid.forEach(function (product) {
        var card = buildCard(product);
        renderLikeButton(card.querySelector('.wishlist-card__like'), product.handle, labels);
        grid.appendChild(card);
      });

      if (valid.length !== handles.length) {
        window.VioletEyesLikes.writeLiked(valid.map(function (p) { return p.handle; }));
      }

      setHidden(grid, false);
      setHidden(subtitle, false);
      setHidden(emptyState, true);
    });
  }

  ready(function () {
    setBackLink();
    loadWishlist();
    document.addEventListener('like:card-removed', function () {
      window.setTimeout(function () {
        var grid = document.querySelector('[data-wishlist-grid]');
        if (grid && grid.children.length === 0) {
          loadWishlist();
        }
      }, 50);
    });
  });
})();